

















import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { Response_ } from "@/plugins/axios/response";
import { ApiResponse } from "@/types/types";
import { store } from "@/store/store";

export default Vue.extend({
  name: "PosteDeleteModal",
  components: {
    Modal,
    Paragraph
  },
  props: {
    poste_id: {
      type: String || undefined,
      default: undefined
    },
    should_display: {
      type: Boolean,
      default: false
    },
    onAction: {
      type: Function,
      default: () => undefined
    },
    onDelete: {
      type: Function,
      default: () => undefined
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async validate() {
      this.loading = true;
      const response = await this.onDelete();
      if (response.status === ApiResponse.SUCCESS) {
        this.onAction({
          type: "SUCCESS",
          title: "Suppression",
          content: (response as Response_).message
        });
        this.loading = false;
        this.should_close();
      } else {
        this.loading = false;
        this.onAction({
          type: "ERROR",
          title: "Suppression",
          content: (response as Response_).message
        });
      }
      this.loading = false;
    },
    should_close() {
      this.$emit("close");
    }
  },
  computed: {
    posteName(): string {
      return store.getters.POSTE_BY_ID[this.poste_id].name_poste;
    }
  }
});
